import { render } from "./OrdersTable.vue?vue&type=template&id=2d4d0760&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=2d4d0760&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4d0760"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QTable,QTr,QTd,QIcon,QPagination});
